import { render, staticRenderFns } from "./AdminHazmats.vue?vue&type=template&id=5264ca42&scoped=true&"
import script from "./AdminHazmats.vue?vue&type=script&lang=js&"
export * from "./AdminHazmats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264ca42",
  null
  
)

export default component.exports